import { ComponentType, createElement as h } from 'react'
import { default as withLoadable } from 'react-loadable'

import { EpicsModule, StoreModule } from 'modules/store'

type LoadingComponentProps = withLoadable.LoadingComponentProps

type ModuleComponent<P = any> = ComponentType<P> &
  Partial<{
    forFeature: ForFeatureFn
  }>
type EsModule<M extends object> = {
  default: M
}

interface ForFeatureFn extends Function {
  __hasBeenCalled?: boolean
  (): ForFeatureFnReturn
}
export interface ForFeatureFnReturn<P extends {} = {}> {
  providers?: P
  epics?: any[]
  store?: {
    id: string
    reducers: any
  }
}

type ModuleLoaderConfig<L extends object> = Partial<{
  loading: ComponentType<any>
  logger: Console | L
  storeModule: StoreModule | null
  epicsModule: EpicsModule | null
}>

const DefaultLoading = (props: LoadingComponentProps) => {
  if (props.error) {
    return h('div', {}, 'Error!')
  }
  if (props.timedOut) {
    return h('div', {}, 'Taking a long time...')
  }
  if (props.pastDelay) {
    return h('div', {}, 'Loading...')
  }

  return null
}

const config: ModuleLoaderConfig<Console> = {
  loading: DefaultLoading,
  logger: console,
  storeModule: null,
  epicsModule: null,
}

export function configureModuleLoader(options: ModuleLoaderConfig<object> = {}): void {
  Object.assign(config, options)
}
export function loadModule(loader: () => Promise<EsModule<ModuleComponent>>, Loading = DefaultLoading) {
  return withLoadable({
    loader() {
      return loader().then(resolveModule)
    },
    loading() {
      return h(Loading)
    },
  })
}

function resolveModule(loadedModule: EsModule<ModuleComponent>) {
  const Cmp = loadedModule.default

  if (Cmp.forFeature) {
    if (Cmp.forFeature.__hasBeenCalled) {
      config.logger!.error(
        `${
          Cmp.name
        }.forFeature() has been already called, please make sure you don't pass result of loadComponent() directly to router path, extract it to separate component`
      )
    } else {
      Cmp.forFeature.__hasBeenCalled = true
    }

    const { epics, providers, store } = Cmp.forFeature()
    if (store && config.storeModule) {
      config.storeModule.inject(store.id, store.reducers)
    }
    if (epics && providers && config.epicsModule) {
      config.epicsModule.inject(epics, providers)
    }
  }

  return Cmp
}



// WEBPACK FOOTER //
// ./src/modules/module-loader/load-module.ts